<template>
    <span>{{ item.user.tag }} liked a challenge</span>
</template>

<script>
export default {
    props: {
        item: {
            required: true,
            type: Object
        }
    }
};
</script>
